<style scoped>
  .consent-terms {
    font-family: inherit;
    font-size: 15px;
    line-height: 1.6;
    text-align: justify;
    color: #4c4d4f;
    padding: 8px 24px 24px;
    white-space: normal;
    word-wrap: break-word;
  }

  .consent-terms h2 {
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    line-height: 1.3;
    margin: 8px 0 24px;
  }

  .consent-terms-actions {
    display: flex;
    justify-content: center;
    padding: 0 24px 24px;
  }
</style>
<template>
	<Modal
		v-model="dialog"
		modalTitle="Termos de Uso"
		:cardTitle="true"
		:withClose="true"
		myMaxWidth="640px"
		@input="$emit('close')"
	>
		<!-- Antes o bloco exigia person E entity. O entity vinha de um caminho que nao
			existe no payload, entao a modal abria vazia: o termo nunca aparecia. Agora
			depende so de person, e cada linha de identificacao se protege sozinha. -->
		<v-container fluid pa-0 v-if="person">
			<v-layout pa-0>
				<v-flex list-scroll sm12 style="height:82vh">
					<div class="content-text-block overflow font-sys">
						<div class="consent-terms">
              <h2>TERMO DE ADESÃO AO TRABALHO VOLUNTÁRIO</h2>

                IDENTIFICAÇÃO DO VOLUNTÁRIO DA AÇÃO VOLUNTÁRIA
                {{ person.name }}, inscrito no CPF sob nº {{ CpfFormat(person.cpf) }}<template v-if="personAddress">, residente e domiciliado na {{ personAddress.street }}, {{ personAddress.number }}, {{ personAddress.neighborhood }}, {{ personAddress.city }} - {{ personAddress.state }}</template>, doravante designado
                simplesmente “Voluntário” <br><br>
                <template v-if="entity">
                IDENTIFICAÇÃO DA GESTORA DA AÇÃO VOLUNTÁRIA:
                {{ entity.name }}, inscrito no CNPJ sob nº {{ CnpjFormat(entity.cnpj) }}<template v-if="entityAddress">, com sede na {{ entityAddress.street }}, {{ entityAddress.number }}, {{ entityAddress.neighborhood }}, {{ entityAddress.city }} - {{ entityAddress.state }}</template> doravante designado
                simplesmente “Gestora”<br><br>
                IDENTIFICAÇÃO DA ENTIDADE APOIADA PELA AÇÃO VOLUNTÁRIA:
                {{ entity.name }}, inscrito no CNPJ sob nº {{ CnpjFormat(entity.cnpj) }}<template v-if="entityAddress">, com sede na {{ entityAddress.street }}, {{ entityAddress.number }}, {{ entityAddress.neighborhood }}, {{ entityAddress.city }} - {{ entityAddress.state }}</template>, doravante designado simplesmente “Entidade”<br><br>
                </template>
                O presente Termo de Adesão tem como objeto a regulamentação de atividades não remuneradas a
                serem executadas pelo Voluntário acima identificado nos termos da Lei 9608/98, relativas à(s)
                ação(ões) gerenciadas pela Gestora e promovidas pela Entidade no âmbito do {{ offerName }}, sob as condições a seguir especificadas:<br><br>
                1. Por força do presente Termo de Adesão o Voluntário poderá:<br>
                a) Optar, a seu exclusivo critério e de forma eletrônica no Portal da Abrace Uma Causa pela(s)
                ação(ões) voluntária(s) em que queira atuar no âmbito do {{ offerName }}, sendo
                que as condições específicas relativas a cada ação estarão detalhadas neste mesmo canal de
                comunicação;<br><br>
                b) Contribuir isoladamente ou em grupo conforme características específicas de cada ação
                gerenciada pela Gestora e promovida pela Entidade, junto a Organizações Sociais, Escolas
                Públicas, Empresas Parceiras e/ou comunidade em geral, sendo permitido ao Voluntário atuar
                em atividades de gestão, pedagogia, infraestrutura de Organização Social ou escola nas
                temáticas que envolvam esporte &amp; recreação, arte &amp; cultura, meio ambiente, diversidade,
                empreendedorismo &amp; geração de renda, arrecadação e entrega de materiais, orientação
                financeira ao público em geral e/ou quaisquer outras atividades necessárias ao integral
                cumprimento das finalidades específicas relacionadas à(s) ação(ões) promovida(s) pela
                Entidade e gerenciada pela Gestora para a qual(is) o voluntário tenha escolhido atuar.<br><br>
                2. Os serviços a serem prestados pelo Voluntário no âmbito do {{ offerName }}
                possuem caráter gratuito, não cabendo remuneração a título de contraprestação; não havendo vínculo
                trabalhista e nem obrigação de natureza trabalhista, previdenciária ou afim.<br><br>

                3. O presente Termo de Adesão vigorará por prazo indeterminado a partir da data de sua
                assinatura, podendo ser rescindido por qualquer das Partes a qualquer tempo, devendo a outra Parte
                ser comunicada com antecedência mínima de 30 dias.<br><br>
                4. O Voluntário neste ato autoriza a Gestora e a Entidade a utilizarem e efetuar o tratamento dos
                dados relativos as imagens e a voz do Voluntário acima identificado captadas por meio de filmagens e
                fotografias, bem como das declarações, depoimentos, relatos das atividades realizadas relativas à
                atuação do Voluntário no {{ offerName }}, pelo prazo em que vigorar cada ação para a qual
                o voluntário tenha escolhido atuar, com o objetivo de efetuar sua divulgação e como material
                institucional da referida Ação e/ou do {{ offerName }}, podendo utilizar este material ou
                respectivas reproduções no mundo inteiro, , no todo ou em parte, em conexão com o {{ offerName }}.
                As Partes elegem o Foro Central da Comarca da Capital de São Paulo para dirimir questionamentos
                sobre este Contrato, renunciando a qualquer outro.
                E, ESTANDO ASSIM JUSTAS E CONTRATADAS, celebram as Partes o presente instrumento.<br><br>

                <!-- Termo escrito pelo gestor no Passo 5. Os dois chamadores sempre
                     passaram :consentTerms, mas a prop nao era declarada aqui, entao o
                     texto era descartado em silencio. -->
                <div v-if="consentTerms" v-html="consentTerms"></div>
            </div>
            <div class="consent-terms-actions" v-if="!fromDash">
              <v-btn
                flat round color="white" class="btn-blue text-uppercase"
                @click="$emit('accept')"
              >
                Concordo
              </v-btn>
            </div>
					</div>
          
				</v-flex>
			</v-layout>
		</v-container>

		<!-- Sem perfil a modal abria totalmente vazia, sem dizer o que houve nem o que
			fazer. Estes dois estados garantem que ela sempre comunique alguma coisa. -->
		<v-container fluid pa-0 v-else>
			<div class="consent-terms consent-terms-feedback">
				<p v-if="loadingProfile">Carregando seus dados…</p>
				<template v-else>
					<p>Não foi possível carregar seus dados para gerar o termo de adesão.</p>
					<p>Entre na sua conta e tente novamente.</p>
					<div class="consent-terms-actions">
						<v-btn flat round color="white" class="btn-blue text-uppercase" @click="ensureProfile">
							Tentar novamente
						</v-btn>
					</div>
				</template>
			</div>
		</v-container>
	</Modal>
</template>
<script type="plain/text">
import Modal from "@/components/Modal.vue";
import PersonService from "@/scripts/services/person.service.js";

export default {
	props: {
    value: Boolean,
    // Termo da vaga, escrito pelo gestor no Passo 5. Os chamadores sempre passaram
    // :consentTerms; faltava declarar aqui.
    consentTerms: String,
    info: Object,
    fromDash: Boolean
  },
	components: {
		Modal, 
	},
	data() {
		return {
      personService: new PersonService(),
      dialog: false,
      person: null,
      loadingProfile: false,
		};
	},
  computed: {
    /**
     * Entidade que aparece como Gestora e como Entidade no termo.
     *
     * Era `info.institution.entity`, caminho que nao existe em nenhum dos dois
     * chamadores: a leitura estourava TypeError dentro do computed, a render da modal
     * falhava e nada aparecia na tela. O payload traz a instituicao em dois formatos
     * diferentes, e os dois sao aceitos aqui:
     *
     *   - vindo da landing page, a vaga carrega `volunteering.institution` (preenchido
     *     por VolunteeringAttributeOfferBusiness.FindAllByCampaignId);
     *   - vindo de Meu Voluntariado, `volunteering` JA E a instituicao, porque o card
     *     preenche esse campo com o retorno de FindInstitutionByVolunteeringId.
     *
     * Sem nenhum dos dois, devolve null em vez de estourar -- o termo continua abrindo,
     * so sem o bloco de identificacao das entidades.
     */
    entity() {
      const info = this.info;
      if (!info) return null;

      const volunteering = info.volunteering;

      if (volunteering && volunteering.institution && volunteering.institution.entity)
        return volunteering.institution.entity;

      if (volunteering && volunteering.entity) return volunteering.entity;

      if (info.institution && info.institution.entity) return info.institution.entity;

      return null;
    },
    entityAddress() {
      return this.entity && this.entity.address ? this.entity.address : null;
    },
    personAddress() {
      return this.person && this.person.address ? this.person.address : null;
    },
    // info pode nao estar preenchido no primeiro render do pai, e o nome da vaga
    // aparece sete vezes no corpo do termo -- ler direto derrubava a render.
    offerName() {
      return this.info && this.info.offerName ? this.info.offerName : "";
    }
  },
  watch: {
    // Espelha a prop num estado proprio. Antes o watch atribuia a propria prop, e o
    // v-model do Modal tambem escrevia nela -- mutacao de prop, que o Vue recusa.
    value: {
      handler(val) {
        this.dialog = val;
        if (val) this.ensureProfile();
      },
      immediate: true
    }
  },
  methods: {
    /**
     * Busca o perfil na ABERTURA da modal, e nao mais no mounted.
     *
     * O componente monta junto com a landing page, quase sempre com o usuario ainda
     * deslogado, e o GetProfile exige token -- a chamada falhava ali e nada mais era
     * tentado. Como todo o corpo do termo (inclusive o botao "Concordo") vive sob
     * v-if="person", quem entrava deslogado e logava durante a inscricao via a modal
     * abrir VAZIA pelo resto da sessao e ficava sem conseguir aceitar o termo.
     */
    ensureProfile() {
      if (this.person || this.loadingProfile) return;

      this.loadingProfile = true;
      this.personService.getProfile(this.getProfileCallback);
    },
    getProfileCallback(data) {
      this.loadingProfile = false;
      // Em falha (sem token, por exemplo) o service devolve o retorno ja tratado, sem
      // a Person. O criterio e deliberadamente largo -- basta parecer um perfil: um
      // teste estreito demais esconderia o termo de novo, que e justamente o bug.
      this.person = data && (data.id || data.name) ? data : null;
    },
    // Documento sem CPF ou CNPJ cadastrado devolve string vazia. Antes chamava replace
    // em null e derrubava a render junto com o resto do termo.
    CpfFormat(cpf){
      if (!cpf) return "";
      //retira os caracteres indesejados...
      cpf = cpf.replace(/[^\d]/g, "");
      
      //realizar a formatação...
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
    CnpjFormat(cnpj) {
      if (!cnpj) return "";
      return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
    },
	}
};
</script>
